import 'dayjs/locale/ru';
import axios from 'axios';
import dayjs from 'dayjs';
import Observer from '../../common/scripts/observer';
// import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class FavoriteButton {
    constructor() {
        /**
         * Массив с ID избранных элементов
         * @type {array}
         */
        this.favorite = [];

        /**
         * Массив со всеми кнопками избранного на страничке
         * @type {null|array}
         */
        this.favoriteButtons = null;
        this.favoriteButtonsTooltips = null;

        /**
         * Активный класс
         * @type {string}
         */
        this.activeClass = 'is-active';

        /**
         * Класс, помечающий кнопку избранного,
         * на которую кликнули первой (убирается после синхронизации)
         * @type {string}
         */
        this.initClass = 'is-first-init';

        /**
         * Блоки "вернуть назад в избранное" в карточке квартиры
         * @type {*[]}
         */
        this.returnBlocks = [];

        this.parent = null;

        /**
         * Адрес запросов на сервер
         * @type {string}
         */
        this.action = '/api/estate/premises/favorite';

        /**
         * Тип запроса
         * @type {string}
         */
        this.requestType = '';

        /**
         * Тип недвижимости - по умолчанию flats, для коммерции надо переопределить
         * @type {string}
         */
        this.estateType = 'flats';
    }

    init(options) {
        this.favoriteButtons = options.favoriteButtons;
        this.favoriteButtonsTooltips = this.favoriteButtons?.map((button) => {
            return button.querySelector('.j-button__tooltip');
        });

        this._getFavorite();

        this._bindEvents();
    }

    _getFavorite() {
        const chosenFlats = document.querySelectorAll('.j-favorite.is-active');

        chosenFlats.forEach((item) => {
            this.favorite.push(item.getAttribute('data-id'));
        });

        const uniqueFavSet = new Set(this.favorite);

        this.favorite = [...uniqueFavSet];
    }

    /**
     * Навешиваем обработчики событий
     * @private
     */
    _bindEvents() {
        if (!this.favoriteButtons.length) {
            return;
        }

        this.favoriteButtons.forEach((button) => {
            const id = button.dataset.id;
            const title = button.dataset.title;
            const tooltip = button.querySelector('.j-button__tooltip');
            const closeButton = button.querySelector('.j-tooltip__close');

            button.setAttribute('data-init', true);

            button.addEventListener('click', (event) => {
                const type = button.dataset.type;

                event.preventDefault();
                this.parent = button.closest('.j-favorites-flat');

                this._checkIsDisabledFlat(button);

                this._setFavorite(id, type);

                button.classList.toggle(this.activeClass);
                button.classList.add(this.initClass);

                this._syncFavorite(id);

                const removed = this.favoriteButtonsTooltips.filter((innerTooltip) => {
                    const isOpened = innerTooltip.classList.contains('force-tooltip-open');

                    if (isOpened) {
                        innerTooltip.classList.remove('force-tooltip-open');
                    }

                    return isOpened;
                });

                if (removed.length) {
                    setTimeout(() => {
                        this._setTooltip(tooltip, button.classList.contains(this.activeClass), title);
                    }, 300);
                } else {
                    this._setTooltip(tooltip, button.classList.contains(this.activeClass), title);
                }

                setTimeout(() => {
                    this._setTooltip(tooltip, button.classList.contains(this.activeClass));
                }, 2500);
            });

            closeButton?.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                this._setTooltip(tooltip, button.classList.contains(this.activeClass));
            });
        });

        if (!this.returnBlocks.length) {
            return;
        }

        this.returnBlocks.forEach((item) => {
            item.button.addEventListener('click', (event) => {
                event.preventDefault();
                this._setFavorite(item.id);

                item.favoriteButton.classList.toggle(this.activeClass);
                item.favoriteButton.classList.add(this.initClass);

                this._syncFavorite(item.id);
            });
        });
    }

    /**
     * Меняет текст в тултипе
     * @param {HTMLElement} tooltip - тултип конкретной кнопки
     * @param {boolean} isActive - активна ли кнопка
     * @param {string} title - название квартиры
     * @private
     */
    _setTooltip(tooltip, isActive, title = '') {
        if (!tooltip) {
            return;
        }

        const innerSpan = tooltip.querySelector('span');

        if (title) {
            const action = isActive ? 'Добавлено' : 'Удалено';
            const date = dayjs().locale('ru')
                .format('HH:mm, D MMMM YYYY');

            tooltip.classList.add('force-tooltip-open');

            innerSpan.innerHTML = `
                <div class="tooltip__action">${action}</div>
                <div class="tooltip__title">${title}</div>
                <div class="tooltip__date">${date}</div>
            `;
        } else {
            this.favoriteButtonsTooltips.forEach((innerTooltip) => {
                innerTooltip.classList.remove('force-tooltip-open');
            });
        }
    }

    /**
     * Сихнронизирует квартиры на странице:
     * когда добавляем в избранное квартиру из шахматки,
     * та же самая квартира в табличном виде тоже должна обновиться
     * @param {string} id - id элемента
     */
    _syncFavorite(id) {
        this.favoriteButtons.forEach((item) => {
            if (item.getAttribute('data-id') === id && !item.classList.contains(this.initClass)) {
                item.classList.toggle(this.activeClass);
            }
        });

        this.favoriteButtons.forEach((item) => {
            if (item.classList.contains(this.initClass)) {
                item.classList.remove(this.initClass);
            }
        });
    }

    /**
     * Добавляем или удаляем квартиру из избранного по id
     * @param {string} id - id элемента
     * @param {string} type - тип элемента
     */
    _setFavorite(id, type) {
        this._getFavorite();
        // Проверяем, есть ли элемент в массиве
        let isExist = -1;

        if (this.favorite.length) {
            isExist = this.favorite.findIndex((item) => {
                return item === id;
            });
        }

        // Если есть, удаляем, если нет - сохраняем в массив
        if (isExist > -1) {
            this.favorite.splice(isExist, 1);
            this._showReturnBlock(id);
            this.requestType = 'removeFavorite';
        } else {
            this.favorite.push(id);
            this._hideReturnBlock(id);
            this.requestType = 'addFavorite';
        }

        if (type === 'commerces') {
            this.estateType = 'commerces';
        }

        const favoriteData = new FormData();

        favoriteData.append('requestType', this.requestType);
        favoriteData.append('estateType', this.estateType);
        favoriteData.append('id', id);

        axios.post(this.action, favoriteData)
            .then((response) => {
                const success = response.data.success;

                if (success) {
                    this.data = response.data.data;
                    const count = this.data.favorites || 0;

                    observer.publish('favorite:update', count);
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    /**
     * Показывает блок для возврата квартиры в избранное (если квартира не задизейблена)
     * @param {string} id - id элемента
     * @private
     */
    _showReturnBlock(id) {
        if (!this.returnBlocks.length || this.parent?.classList.contains('is-disabled')) {
            return;
        }

        const returnBlock = this.returnBlocks.find((item) => {
            return item.id === id;
        });

        if (!returnBlock) {
            return;
        }

        returnBlock.block.classList.add('is-active');
    }

    /**
     * Скрывает блок для возврата квартиры в избранное
     * @param {string} id - id элемента
     * @private
     */
    _hideReturnBlock(id) {
        if (!this.returnBlocks.length) {
            return;
        }

        const returnBlock = this.returnBlocks.find((item) => {
            return item.id === id;
        });

        if (!returnBlock) {
            return;
        }

        returnBlock.block.classList.remove('is-active');
    }

    _checkIsDisabledFlat(button) {
        this.parent = button.closest('.j-favorites-flat.is-disabled');

        if (!this.parent) {
            return;
        }

        this.parent.style.pointerEvents = 'none';
    }
}

export default FavoriteButton;
